export default {
  impacts: 'Impacts',
  dependencies: 'Dépendances',
  noEventsFilter: 'Sans évènements récents',
  impactChain: 'Chaîne d\'impact',
  resolvedAlarms: 'Alarmes résolues',
  activeAlarm: 'Alarme active',
  impactDepends: 'Impacts/Dépendances',
  treeOfDependencies: 'Arbre de dépendances',
  charts: 'Graphiques',
  infosSearchLabel: 'Rechercher une info',
  eventStatisticsMessage: '{ok} OK événements\n{ko} KO événements',
  eventStatistics: 'Statistiques d\'événement',
  addSelection: 'Ajouter une sélection',
  actions: {
    titles: {
      editEntity: 'Éditer l\'entité',
      duplicateEntity: 'Dupliquer l\'entité',
      deleteEntity: 'Supprimer l\'entité',
      pbehavior: 'Comportement périodique',
      variablesHelp: 'Liste des variables disponibles',
      massEnable: 'Activer les entités',
      massDisable: 'Désactiver les entités',
    },
  },
  fab: {
    common: 'Ajouter une nouvelle entité',
    addService: 'Ajouter une nouvelle entité de service',
  },
  popups: {
    massDeleteWarning: 'La suppression en masse ne peut pas être appliquée pour certains des éléments sélectionnés, ils ne seront donc pas supprimés.',
    exportFailed: 'Échec de l\'exportation des entités au format CSV',
  },
};
